<nz-spin [nzSpinning]="loading">
  <nz-row>
    <form nz-form [formGroup]="form" (ngSubmit)="submitForm()" style="width: 100%">
      @if (orderType !== orderTypes.MIXED && editObject?.id) {
        <div class="order-head">
          <div class="order-head-meta">
            <span>Bestelltermin <b>{{ form.get('orderDate').value | dateFormat }}</b></span>
            <span>Lieferung erwartet <b>{{ form.get('estimatedDelivery').value ? (form.get('estimatedDelivery').value | dateFormat) : 'nicht gesetzt' }}</b></span>
            <span>Bestellt von <b>{{ form.get('orderer').value?.name || form.get('orderer').value?.fullName || '–' }}</b></span>
            <span>Rechnung <b>{{ form.get('isInvoiceUploaded').value ? 'liegt vor' : 'nein' }}</b></span>
            <span>Bezahlt <b>{{ form.get('isPaid').value ? 'ja' : 'nein' }}</b></span>
          </div>
          <div class="order-head-progress">
            <nz-progress [nzPercent]="progressPercent()" [nzShowInfo]="false" nzSize="small"></nz-progress>
            <div class="order-head-progress-text">
              <b>{{ bookedQty() }} von {{ orderedQty() }} Stück</b> eingebucht ·
              {{ productFormList?.length || 0 }} Positionen, davon {{ openPositionCount() }} offen
            </div>
            <button
              nz-button
              nzType="primary"
              type="button"
              [disabled]="!bookAllRows().length || bookAllBusy"
              (click)="openBookAll()"
            >alles einbuchen</button>
          </div>
        </div>
      }

      <nz-col>
        <div class="order-groups">
          <div class="order-group">
            <h4>Bestellung</h4>
            <nz-form-item>
              <nz-form-label nzFor="supplier" nzRequired>Lieferant</nz-form-label>
              <nz-form-control nzErrorTip="Feld ist erforderlich!">
                <span [hidden]="!isAllProductsOpen()">{{ form['controls'].supplier.value?.name || form['controls'].supplier.value?.value }}</span>
                <nz-select
                  [hidden]="isAllProductsOpen()"
                  nzPlaceHolder="Lieferant wählen"
                  nzShowSearch
                  nzServerSearch
                  formControlName="supplier"
                  (nzOnSearch)="onSearchSupplier($event)"
                  [compareWith]="compareSimpleList"
                  (ngModelChange)="!isEdit ? onSupplierChange() : null"
                >
                  @for (o of suppliersList; track o) {
                    @if (!isSuppliersLoading) {
                      <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
                    }
                  }
                  @if (isSuppliersLoading) {
                    <nz-option nzDisabled nzCustomContent>
                      <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                    </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="orderDate" nzRequired>Bestelltermin</nz-form-label>
              <nz-form-control nzErrorTip="Feld ist erforderlich">
                <span [hidden]="!isAllProductsOpen()">{{ form['controls'].orderDate.value | dateFormat }}</span>
                <nz-date-picker [hidden]="isAllProductsOpen()" [nzFormat]="dateFormat" formControlName="orderDate"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
            @if (orderType !== orderTypes.MIXED) {
              <nz-form-item>
                <nz-form-label nzFor="orderer" nzRequired>Bestellt von</nz-form-label>
                <nz-form-control nzErrorTip="Geben Sie die Bearbeiter!">
                  <nz-select
                    nzPlaceHolder="Bearbeiter wählen"
                    nzShowSearch
                    nzServerSearch
                    formControlName="orderer"
                    (nzOnSearch)="onSearchUsers($event)"
                    [compareWith]="compareSimpleList"
                  >
                    @for (o of usersList; track o) {
                      @if (!isUsersLoading) {
                        <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
                      }
                    }
                    @if (isUsersLoading) {
                      <nz-option nzDisabled nzCustomContent>
                        <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                      </nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            }
          </div>

          @if (orderType !== orderTypes.MIXED) {
            <div class="order-group">
              <h4>Liefereingang</h4>
              <nz-form-item>
                <nz-form-label nzFor="handler">Angenommen von</nz-form-label>
                <nz-form-control>
                  <nz-select
                    nzPlaceHolder="Bearbeiter wählen"
                    nzShowSearch
                    nzServerSearch
                    formControlName="handler"
                    (nzOnSearch)="onSearchHandlers($event)"
                    [compareWith]="compareSimpleList"
                  >
                    @for (o of handlersList; track o) {
                      @if (!isHandlersLoading) {
                        <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
                      }
                    }
                    @if (isHandlersLoading) {
                      <nz-option nzDisabled nzCustomContent>
                        <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                      </nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label nzFor="estimatedDelivery">Lieferung erwartet am</nz-form-label>
                <nz-form-control>
                  <nz-date-picker [nzFormat]="dateFormat" formControlName="estimatedDelivery" nzPlaceHolder="Datum wählen"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
              @if (editObject?.id) {
                <nz-form-item>
                  <nz-form-label nzFor="status">Status</nz-form-label>
                  <nz-form-control>
                    <nz-select formControlName="status" nzPlaceHolder="Status">
                      @for (status of deliveryOrderStatuses | keyvalue; track status) {
                        <nz-option [nzValue]="status.key" [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              }
            </div>

            <div class="order-group">
              <h4>Rechnung</h4>
              <nz-form-item>
                <nz-form-label nzFor="invoiceDate">Rechnungsdatum</nz-form-label>
                <nz-form-control>
                  <nz-date-picker [nzFormat]="dateFormat" formControlName="invoiceDate" nzPlaceHolder="Datum wählen"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label nzFor="invoiceType">Rechnungsart</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="invoiceType" nzPlaceHolder="wählen">
                    @for (o of invoiceTypes | keyvalue; track o) {
                      <nz-option [nzValue]="o.value" [nzLabel]="o.key"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <div class="order-switch">
                <nz-switch formControlName="isInvoiceUploaded"></nz-switch>
                <span>Rechnung liegt vor</span>
              </div>
              <div class="order-switch">
                <nz-switch formControlName="isPaid"></nz-switch>
                <span>bezahlt</span>
              </div>
            </div>
          }
        </div>

        <div class="order-groups order-groups-2">
          <div class="order-group">
            <h4>Bemerkung zur Bestellung</h4>
            <textarea nz-input formControlName="comment" rows="3" placeholder="Gilt für die ganze Bestellung"></textarea>
            <div class="order-cap">Mit Verfasser und Zeitpunkt im Änderungsprotokoll nachvollziehbar.</div>
          </div>
          <div class="order-group">
            <h4>Bestelldokumente · {{ documentsList().length }}</h4>
            <div class="d-flex align-items-center" style="gap: 8px; margin-bottom: 8px;">
              <nz-upload
                [nzAction]="toolsService.getUploadDocumentUrl(uploadDocumentTypes.ORDER)"
                [nzHeaders]="{ authorization: 'authorization-text' }"
                nzAccept="application/pdf,image/*"
                [nzShowUploadList]="false"
                nzMultiple
                [nzDisabled]="isFileUploading"
                (nzChange)="handleChange($event)"
              >
                <button nz-button type="button">
                  <i nz-icon nzType="upload"></i>
                  hochladen
                </button>
              </nz-upload>
              @if (isFileUploading) {
                <nz-spin nzSimple nzSize="small"></nz-spin>
              }
            </div>
            @if (documentsList().length > 0) {
              <table class="doc-table">
                <thead>
                  <tr>
                    <th>Datei</th>
                    <th>Art</th>
                    <th>Größe</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (doc of documentsList(); track doc.s3Key) {
                    <tr>
                      <td>
                        <b>{{ doc.fileName }}</b>
                        @if (doc.uploadedBy?.fullName) {
                          <div class="order-cap">{{ doc.uploadedBy.fullName }}</div>
                        }
                      </td>
                      <td>
                        <nz-select [ngModel]="doc.kind" [ngModelOptions]="{standalone: true}" (ngModelChange)="setDocumentKind(doc.s3Key, $event)" style="width: 140px">
                          @for (kind of documentKinds; track kind) {
                            <nz-option [nzValue]="kind" [nzLabel]="kind"></nz-option>
                          }
                        </nz-select>
                      </td>
                      <td>{{ formatSize(doc.sizeBytes) }}</td>
                      <td class="d-flex" style="gap: 6px">
                        <app-download-document [documentKey]="doc.s3Key"></app-download-document>
                        <i
                          nz-icon
                          nzType="delete"
                          nzTheme="outline"
                          nz-popconfirm
                          nzPopconfirmTitle="Dokument wirklich löschen?"
                          (nzOnConfirm)="removeDoc(doc.s3Key)"
                        ></i>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
        @if (orderType === orderTypes.NonPacking && editObject?.id) {
          <div class="order-group">
            <h4>Mailverlauf</h4>
            @if (orderMailsLoading) {
              <nz-spin nzSimple nzSize="small"></nz-spin>
            } @else if (orderMailsError) {
              <div class="order-cap">Mailverlauf konnte nicht geladen werden.</div>
            } @else if (!orderMails.length) {
              <div class="order-cap">Keine E-Mails</div>
            } @else {
              <table class="doc-table">
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Status</th>
                    <th>Empfänger</th>
                    <th>CC</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (mail of orderMails; track mail.id) {
                    <tr>
                      <td class="cell-nowrap">{{ mail.createdAt | date:'short' }}</td>
                      <td class="cell-nowrap">
                        <span class="status-pill" [attr.data-status]="mailStatusKind(mail.status)">{{ mailStatusLabel(mail.status) }}</span>
                      </td>
                      <td>{{ joinEmails(mail.toEmails) }}</td>
                      <td>{{ joinEmails(mail.ccEmails) }}</td>
                      <td>
                        <button nz-button nzType="link" type="button" (click)="toggleMail(mail.id)">Inhalt</button>
                      </td>
                    </tr>
                    @if (openMailIds.has(mail.id)) {
                      <tr>
                        <td colspan="5">
                          <div class="order-cap">{{ mail.subject }} · {{ mail.fromEmail }} · Antwort an {{ mail.replyTo || '–' }}</div>
                          @if (mail.errorMessage) {
                            <div class="order-cap">{{ mail.errorMessage }}</div>
                          }
                          <pre class="mail-body">{{ mail.body }}</pre>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            }
          </div>
        }
      </nz-col>
      <nz-col>
        <div class="positions-head">
          <h4>Positionen</h4>
          <button nz-button (click)="addProductRow()" nzType="default" type="button" id="add-product-row">Artikel hinzufügen</button>
          <span class="order-cap" style="margin-left: auto">
            {{ (productFormList?.length || 0) - openPositionCount() }} Position eingebucht · {{ openPositionCount() }} offen
          </span>
        </div>
        <nz-table #tableRef #editRowTable nzBordered [nzData]="[{}]" [nzShowPagination]="false">
          <thead>
            <tr>
              @if (isEdit) {
                <th nzWidth="75px">#ID</th>
              }
              <th width="220">Artikel</th>
              <th>bestellt</th>
              @if (orderType !== orderTypes.Bagable) {
                <th>geliefert</th>
                <th>offen</th>
              }
              <th width="10%">Lieferdatum</th>
              <th>Charge</th>
              <th width="10%">MHD</th>
              <th>Kommentar</th>
              <th>Status</th>
              <th nzAlign="left"></th>
            </tr>
          </thead>
          <tbody>
            @for (data of form.get('orderProducts')['controls']; track data; let i = $index) {
              <tr
                (click)="startEdit(i)"
                formArrayName="orderProducts"
                class="editable-row"
                [class.row-err]="rowBookState[data['controls'].id.value] === 'error'"
              >
                <ng-container [formGroupName]="i">
                  @if (isEdit) {
                    <td>{{ data['controls'].id.value && data['controls'].id.value !== -1 ? data['controls'].id.value : '' }}</td>
                  }
                  <td>
                    <div style="max-width: 250px;">
                      <div class="editable-cell" [hidden]="editRow === i && data['controls'].isNew.value">
                        {{ data['controls'].name.value }}
                      </div>
                      <nz-select
                        style="width: 100%"
                        nzPlaceHolder="Artikel wählen"
                        nzShowSearch
                        nzServerSearch
                        nzAllowClear
                        formControlName="product"
                        [hidden]="editRow !== i || !data['controls'].isNew.value"
                        (ngModelChange)="productChange($event); data['controls'].charge.patchValue(null)"
                        (nzOnSearch)="onArticleSearch($event)"
                      >
                        @for (o of articlesList; track o) {
                          @if (!isArticlesLoading) {
                            <nz-option [nzValue]="o.id" [nzLabel]="o.value"></nz-option>
                          }
                        }
                        @if (isArticlesLoading) {
                          <nz-option nzDisabled nzCustomContent>
                            <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                          </nz-option>
                        }
                      </nz-select>
                    </div>
                  </td>
                  <td>
                    <div class="editable-cell" [hidden]="editRow === i && data['controls'].status.value === 'Open'">
                      {{ data['controls'].quantity.value }}
                    </div>
                    <input
                      [hidden]="editRow !== i || data['controls'].status.value !== 'Open'"
                      formControlName="quantity"
                      appPossitiveNumbers
                      type="number" nz-input />
                  </td>
                  @if (orderType !== orderTypes.Bagable) {
                    <td>
                      <div class="editable-cell" [hidden]="editRow === i && data['controls'].status.value == 'Open'">
                        {{ data['controls'].deliveredQuantity.value }}
                      </div>
                      <input
                        [hidden]="editRow !== i || (data['controls'].status.value !== 'Open' && rowBookState[data['controls'].id.value] !== 'error') || data['controls'].id.value === -1"
                        appPossitiveNumbers
                        formControlName="deliveredQuantity"
                        type="number" nz-input />
                    </td>
                    <td>{{ rowOpenQty(data.getRawValue()) }}</td>
                  }
                  <td>
                    <div class="editable-cell" [hidden]="editRow === i && data['controls'].status.value === 'Open'">
                      {{ data['controls'].deliveryDate.value|dateFormat }}
                    </div>
                    <nz-date-picker
                      [nzFormat]="dateFormat"
                      formControlName="deliveryDate"
                      [hidden]="editRow !== i || data['controls'].status.value !== 'Open'"
                    ></nz-date-picker>
                  </td>
                  <td>
                    <div class="editable-cell" [hidden]="editRow === i && data['controls'].status.value === 'Open'">
                      {{ data['controls'].charge.value }}
                    </div>
                    <input
                      [hidden]="editRow !== i || data['controls'].status.value !== 'Open'"
                      formControlName="charge"
                      appChargeInput
                      [initialValue]="editObject?.orderProducts[i]?.charge"
                      [articleId]="data['controls'].articleId.value"
                      [articleVariantId]="data['controls'].articleVariantId.value"
                      type="text" nz-input />
                  </td>
                  <td>
                    <div class="editable-cell" [hidden]="editRow === i && data['controls'].status.value === 'Open'">
                      {{ data['controls'].mhd.value|dateFormat }}
                    </div>
                    <nz-date-picker
                      [nzFormat]="dateFormat"
                      formControlName="mhd"
                      [hidden]="editRow !== i || data['controls'].status.value !== 'Open'"
                    ></nz-date-picker>
                  </td>
                  <td>
                    <div class="editable-cell" [hidden]="editRow === i">{{data['controls'].comment.value}}</div>
                    <input [hidden]="editRow !== i" formControlName="comment" type="text" nz-input />
                  </td>
                  <td>
                    <span class="status-pill" [attr.data-status]="rowStatusKey(data.getRawValue())">
                      @if (rowBookState[data['controls'].id.value] === 'booking') {
                        <span class="spin"></span>
                      }
                      {{ rowStatusLabel(data.getRawValue()) }}
                    </span>
                  </td>
                  <td nzAlign="left">
                    <div class="actions">
                      @if (data['controls'].id.value !== -1 && data['controls'].status.value === 'Open') {
                        <button
                          nz-button
                          nzType="primary"
                          nzSize="small"
                          type="button"
                          [disabled]="rowBookState[data['controls'].id.value] === 'booking'"
                          (click)="bookRow(i); $event.stopPropagation()"
                        >
                          {{ rowBookState[data['controls'].id.value] === 'error' ? 'erneut versuchen' : 'einbuchen' }}
                        </button>
                      }
                      @if (data['controls'].id.value !== -1 && (data['controls'].status.value === 'Finished' || (data['controls'].deliveredQuantity.value > 0))) {
                        <button nz-button nzSize="small" type="button" (click)="openCorrect(i); $event.stopPropagation()">korrigieren</button>
                      }
                      <span>
                        <i
                          nz-icon
                          nzType="copy"
                          (click)="copyRow(i); $event.stopPropagation()"
                          nzTheme="twotone"
                          [nzTwotoneColor]="'#ffaa04'"
                          nz-tooltip
                          nzTooltipTitle="Zeile kopieren"
                        ></i>
                      </span>
                      @if (data['controls'].id.value !== -1 && data['controls'].status.value !== 'Canceled') {
                        <span>
                          <i
                            nz-icon
                            nzType="stop"
                            nz-popconfirm
                            [nzPopconfirmTitle]="data['controls'].status.value === 'Finished' || data['controls'].deliveredQuantity.value
                              ? 'Einbuchung stornieren? Der Bestand wird korrigiert.'
                              : 'Sind Sie sicher?'"
                            (nzOnConfirm)="cancelRow(i)"
                            nzTheme="twotone"
                            [nzTwotoneColor]="'#eb2f96'"
                            nz-tooltip
                            nzTooltipTitle="Zeile Abbrechen"
                          ></i>
                        </span>
                      }
                      @if (data['controls'].id.value == -1) {
                        <span>
                          <i nz-icon nzType="delete"
                            nz-popconfirm
                            nzPopconfirmTitle="Sind Sie sicher?" (nzOnConfirm)="deleteRow(i)"
                            nzTheme="twotone"
                            [nzTwotoneColor]="'#eb2f96'"
                            nz-tooltip
                            nzTooltipTitle="Zeile löschen"
                          ></i>
                        </span>
                      }
                    </div>
                  </td>
                </ng-container>
              </tr>
            }
          </tbody>
        </nz-table>
      </nz-col>
    </form>
  </nz-row>
</nz-spin>

<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isAdditionalProductsModalVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="isAdditionalProductsModalVisible = false"
  [nzWidth]="960"
>
  <ng-template #modalTitle>
    @if (orderType === orderTypes.NonPacking) {
      Artikel zum Lieferanten
    } @else {
      Empfohlene Zusatzprodukte
    }
  </ng-template>
  <ng-template #modalContent>
    @if (orderType === orderTypes.NonPacking) {
      <p class="suggestion-lead">Bisher bestellte Artikel und Artikel, die diesem Lieferanten zugeordnet sind. Ein Artikel kann in beiden Gruppen sein und erscheint dann einmal.</p>
    }
    <nz-table #basicTable [nzData]="additionalProducts" [nzShowPagination]="false" [nzFrontPagination]="false" [nzScroll]="{ x: '960px' }">
      <thead>
        <tr>
          <th class="cell-ellipsis">Name</th>
          @if (orderType === orderTypes.NonPacking) {
            <th nzWidth="240px" class="cell-nowrap">Herkunft</th>
          }
          <th nzRight nzWidth="380px"></th>
        </tr>
      </thead>
      <tbody>
        @for (val of basicTable.data; track val) {
          <tr>
            <td class="cell-ellipsis" nz-tooltip [nzTooltipTitle]="val.value">{{ val.value }}</td>
            @if (orderType === orderTypes.NonPacking) {
              <td class="cell-nowrap">
                @for (label of suggestionLabels(val); track label) {
                  <span class="suggestion-tag">{{ label }}</span>
                }
                @if (!suggestionLabels(val).length) {
                  –
                }
              </td>
            }
            <td nzRight>
              <div class="suggestion-actions">
                @if (articleLink(val); as href) {
                  <a nz-button nzType="default" [href]="href" target="_blank">Artikel öffnen</a>
                }
                <button nz-button nzType="primary" (click)="addSuggestedArticleToOrder(val)">Zur Bestellung hinzufügen</button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="isAdditionalProductsModalVisible = false">Schließen</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="bookAllVisible" nzTitle="Alles einbuchen" [nzFooter]="bookAllFooter" (nzOnCancel)="bookAllVisible = false" [nzWidth]="640">
  <p>Es werden die <b>bestellten Mengen</b> als geliefert gebucht:</p>
  <nz-table [nzData]="bookAllRows()" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>Artikel</th>
        <th>bestellt</th>
        <th>bisher</th>
        <th>wird gebucht</th>
      </tr>
    </thead>
    <tbody>
      @for (row of bookAllRows(); track row.name) {
        <tr>
          <td>{{ row.name }}</td>
          <td>{{ row.ordered }}</td>
          <td>{{ row.delivered }}</td>
          <td><b>{{ row.willBook }}</b></td>
        </tr>
      }
    </tbody>
  </nz-table>
  <div class="order-group" style="margin-top: 12px">
    <nz-form-item>
      <nz-form-label>Lieferdatum für alle</nz-form-label>
      <nz-form-control>
        <nz-date-picker [(ngModel)]="bookAllDeliveryDate" [nzFormat]="dateFormat"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>Charge für alle</nz-form-label>
      <nz-form-control>
        <input nz-input [(ngModel)]="bookAllCharge" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>MHD für alle</nz-form-label>
      <nz-form-control>
        <nz-date-picker [(ngModel)]="bookAllMhd" [nzFormat]="dateFormat"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <ng-template #bookAllFooter>
    <button nz-button nzType="primary" [nzLoading]="bookAllBusy" [disabled]="!bookAllDeliveryDate" (click)="confirmBookAll()">
      {{ bookAllTotal() }} Stück einbuchen
    </button>
    <button nz-button nzType="default" (click)="bookAllVisible = false">Abbrechen</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="correctVisible" nzTitle="Menge korrigieren" [nzContent]="correctContent" [nzFooter]="correctFooter" (nzOnCancel)="correctVisible = false">
  <ng-template #correctContent>
    <p>Gegenbuchung im Bestand. Grund ist Pflicht.</p>
    <nz-form-item>
      <nz-form-label nzRequired>Gelieferte Menge</nz-form-label>
      <nz-form-control>
        <input nz-input type="number" [(ngModel)]="correctQuantity" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired>Grund</nz-form-label>
      <nz-form-control>
        <textarea nz-input rows="3" [(ngModel)]="correctReason"></textarea>
      </nz-form-control>
    </nz-form-item>
  </ng-template>
  <ng-template #correctFooter>
    <button nz-button nzType="primary" [nzLoading]="correctBusy" [disabled]="!correctReason?.trim()" (click)="confirmCorrect()">Speichern</button>
    <button nz-button nzType="default" (click)="correctVisible = false">Abbrechen</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="closeConfirmVisible" nzTitle="Buchung nicht abgeschlossen" [nzFooter]="closeFooter" (nzOnCancel)="closeConfirmVisible = false">
  <p>Eine Buchung läuft oder ist fehlgeschlagen. Betroffene Positionen:</p>
  <ul>
    @for (name of pendingBookingLabels(); track name) {
      <li>{{ name }}</li>
    }
  </ul>
  <ng-template #closeFooter>
    <button nz-button nzType="primary" nzDanger (click)="confirmForceClose()">Trotzdem schließen</button>
    <button nz-button nzType="default" (click)="closeConfirmVisible = false">Zurück</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="concurrencyVisible" nzTitle="Die Bestellung wurde zwischenzeitlich geändert" [nzFooter]="conflictFooter" (nzOnCancel)="concurrencyVisible = false">
  <p>Jemand anderes hat diese Bestellung gebucht. Laden Sie den aktuellen Stand, statt zu überschreiben.</p>
  <ng-template #conflictFooter>
    <button nz-button nzType="primary" (click)="reloadAfterConflict()">neu laden</button>
  </ng-template>
</nz-modal>
